import { Col, Container, Row } from '@paypalcorp/pp-react'
import { isEmpty } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import React, { useEffect, useState } from 'react'
import HamburgerIcon from '../HamburgerSVG'
import LoginButton from '../LoginButton/LoginButton'
import NavigationButtons from '../NavigationButtons/NavigationButtons'
import AiSearch from '../AiSearch'
import PaypalDeveloperSVG from '../PayPalDeveloperSVG'
import './navbar.css'
import { useApplicationContext } from '../../../../provider'

interface FptiData {
  [key: string]: string | number | boolean
}
interface NavbarProps {
  user: any // TODO: define a new interface with all the values expected from the user and add use interface like UserProps
  location: Location
  inverseHeaderScheme: boolean
}

export const Navbar: React.FC<NavbarProps> = ({
  user,
  location,
  inverseHeaderScheme,
}) => {
  const [launcher, setLauncher] = useState<any>(null)
  const [loginURL, setLoginURL] = useState('')
  const [logoutURL, setLogoutURL] = useState('')
  const userLoggedOut = !user?.loggedIn
  const [searchID, setSearchID] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [page, setPage] = useState(1)
  const { experiments } = useApplicationContext()

  const alternateColorFun = (() => {
    if (inverseHeaderScheme) return 'header-web-home'
    return 'header-web-not-home'
  })()

  const fptiData = typeof window !== `undefined` && window.fpti

  const fptiOptions = {
    page: fptiData && fptiData.page,
    pgrp: fptiData && fptiData.pgrp,
    component: 'devdiscoverynodeweb',
    name: 'gen_ai_summary',
    query: searchQuery,
    searchID,
  }

  useEffect(() => {
    if (!isEmpty(user)) {
      setLoginURL(
        user.login.url.replace(
          /PAGEURL/g,
          encodeURIComponent((location && location.href) || '#'),
        ),
      )
      setLogoutURL(
        user.logout.url.replace(
          /PAGEURL/g,
          encodeURIComponent((location && location.href) || '#'),
        ),
      )
    }
  }, [location, user])

  useEffect(() => {
    setLauncher(
      typeof window !== `undefined`
        ? require('@paypalcorp/dx-ui-react/')
        : null,
    )
  }, [])

  /**
   * Opens the ai search modal, initializes search-related state,
   * and logs a click event if fptiData is available for analytics tracking.
   * @function openSheet
   * @returns {void}
   */
  const openSheet = () => {
    if (fptiData) {
      const uuid = uuidv4()
      setSearchID(uuid)

      const data: FptiData = {
        ...fptiOptions,
        link: 'open_search_modal',
        tag: 'open_search_modal',
      }
      const { searchID, ...clickDataToLog } = data
      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick({
          data: clickDataToLog,
        })
      }
    }
    setShowForm(true)
    setPage(1)
  }

  /**
   * Closes the ai search modal, resets search-related state,
   * and logs a click event if fptiData is available for analytics tracking.
   * @function closeSheet
   * @returns {void}
   */
  const closeSheet = () => {
    if (fptiData) {
      const data: FptiData = {
        ...fptiOptions,
        link: 'close_search_modal',
        tag: 'close_search_modal',
      }
      const { searchID, ...clickDataToLog } = data

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick({
          data: clickDataToLog,
        })
      }
    }
    setShowForm(false)
    setPage(1)
    setSearchQuery('')
  }

  return (
    <Container
      fluid={true}
      className={
        !userLoggedOut
          ? `header-web ${alternateColorFun} header-web-loggedIn`
          : `header-web ${alternateColorFun}`
      }
    >
      <Row>
        <Col xs={4} lg={4} className="nav-col_overlap">
          <div className="firstCol-wrapper">
            <HamburgerIcon />
            <a href="/">
              <PaypalDeveloperSVG />
            </a>

            {experiments.aiSearch === 'Trmt_Developer_AI_Search' && launcher ? (
              <launcher.SearchModalToggle
                AiSearch={AiSearch}
                aiProps={{
                  setSearchID,
                  searchID,
                  searchQuery,
                  setSearchQuery,
                  fptiOptions,
                  showForm,
                  setShowForm,
                  page,
                  setPage,
                }}
                onOpen={openSheet}
                onClose={closeSheet}
              />
            ) : (
              <span className={`algoliaSearchlaunch Web ${'search-input'}`}>
                {launcher && <launcher.SearchModal />}
              </span>
            )}
          </div>
        </Col>
        {/* <Col md={1} className="spacer-col" /> */}
        <Col xs={6} lg={6} className="nav-col">
          {/* TODO: this props does not exist on this component - user={user} loginURL={loginURL}  */}
          <NavigationButtons />
        </Col>
        {userLoggedOut ? (
          <Col xs={2} lg={2} className="nav-col">
            <div className="loginButtonWrapper">
              <LoginButton
                user={user}
                loginURL={loginURL}
                searchID={searchID}
              />
            </div>
          </Col>
        ) : null}
      </Row>
    </Container>
  )
}
